import DateFilter from '@/components/date-filter';
import $ from 'jquery'

export default {
    name: 'examens',
    components: {
        DateFilter
    },
    props: [],
    data() {
        return {
            is_loading: true,
            is_empty: false,
            selected_examen: '',
            r_loading: false,

            fields: [ 
                {key:'ref',label: 'Référence'}, 'patient', {key:'age',label: 'Âge'}, 'sexe',
                'prescripteur', 'examen.s', {key:'renseignement_clinque',label: 'Renseignement clinique'}
            ],
            filter: "",
            perPage: 15,
            print_per_page: -1,
            currentPage: 1,

            renseignement_clinique: '',
            current_date_filter: {},
            curr_month: "",          // Current month of the year
            filter_date: '',

            date_filters: [
                { slug: 'date', libelle: 'Date' },
                { slug: 'entre_deux_date', libelle: 'Entre deux dates' }
            ],
            filter_by_date: { slug: '', libelle: '' },
            is_month: false
        }
    },

    watch: {
        filter_date() {
            if (this.filter_date != '') {
                this.filter_by_date = this.filter_date;
                if (this.filter_by_date.slug) {
                    $('.date-filter').modal('show')
                }
            }
        },

        curr_month() {
            const data = {
                month: this.curr_month.id,
                one_date: "",
                from_date: "",
                to_date: "",
                etat_resultat: 0,
                user_id: this.userCredentials.id
            }
            this.current_date_filter = data
            this.is_month = true
            this.listExamenAttente()
        },
    },

    computed: {
        /**
         * Liste of months of the year [ From january to current month ]
         * @returns 
         */
        monthOfYear() {
            let index;
            var m = []
            for (index = 0; index <= this.current_date.getMonth() + 1; index++) {
                m[index] = this.list_months[index];
            }
            return m;
        },

        examen_salle_attente() {
            return this.$store.getters['examen_salle_attente']
        },

        examen_length() {
            return this.examen_salle_attente.length
        },

        types_examens() {
            return this.$store.getters["examens"];
        },

        /**
         * User Info
         * @returns 
         */
        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        activeRole() {
            return this.$store.getters['activeRole'];
        },
    },

    mounted() {
        const data = {
            month: "",
            one_date: this.setDates().today_date,
            from_date: "",
            to_date: "",
            etat_resultat: 0,
            user_id: this.userCredentials.id
        }
        this.current_date_filter = data
        this.listExamenAttente()
        

        this.$store.dispatch("getExamens")
    },

    methods: {
        redirectTo() {
            if (this.selected_examen != '') {
                this.r_loading = true

                this.$store.commit("SET_SELECTED_DATE_FILTER", this.current_date_filter);
                this.$router.push({path: 'salle-examen/'+this.selected_examen.id})
            }
        },

        viewRenseignement(examen_data) {
            this.renseignement_clinique = examen_data.renseignement_clinique
        },

        listExamenAttente() {
            this.is_loading = true
            this.$store.dispatch('getExamenSalleAttente', this.current_date_filter).then(() => {
                if (this.examen_salle_attente.length > 0) {
                    this.is_empty = false
                } else {
                    this.is_empty = true
                }
                this.is_loading = false
            })
        },

        filterByDate(date) {
            const data = {
                month: "",
                one_date: date.single_date,
                from_date: date.from_date,
                to_date: date.to_date,
                etat_resultat: 0,
                user_id: this.userCredentials.id
            }
            this.current_date_filter = data
            this.filter_date = ""
            this.is_month = false

            this.listExamenAttente()
        },
    }
}